import { convertAnnotationToNode } from './utils/annotationsToNodes';
import { addChildNode } from './utils/addChildNode';
import { AnnotationExtra } from './types/Annotations';
import { AppState, defaultDebateMap } from './App';

export async function sendAnnotations(
    annotations: AnnotationExtra[],
    appState: Partial<AppState>,
    setAnnotations: React.Dispatch<React.SetStateAction<AnnotationExtra[]>>,
    jwToken: string) {
    for (const annotation of annotations) {
        try {
            if (annotation.skip === undefined && // Check that it hasn't been skipped
                annotation?.target?.[0]?.selector?.[2]?.exact //Check that there is a quote
            ) {
                const map = appState.isAdvanced ? appState.map : defaultDebateMap;
                const newChildNode = convertAnnotationToNode(annotation, map.id, map.rootNode);

                setAnnotations(annotations => annotations.map(a => {
                    if (a.id === annotation.id) {
                        return { ...a, state: "Sending", error: "" };
                    }
                    return a;
                }));

                const result = await addChildNode(newChildNode, jwToken);

                if (result?.errors?.length > 0) {
                    setAnnotations(annotations => annotations.map(a => {
                        if (a.id === annotation.id) {
                            return {
                                ...a, state: "Error", error: result.errors.map(
                                    //@ts-ignore
                                    e => e.message
                                ).join("\n")
                            };
                        }
                        return a;
                    }))
                } else {
                    setAnnotations(annotations => annotations.map(a => {
                        if (a.id === annotation.id) {
                            return { ...a, state: "Sent" };
                        }
                        return a;
                    }));
                }
            }
        } catch (error) {
            console.error(error);
            setAnnotations(annotations => annotations.map(a => {
                if (a.id === annotation.id) {
                    return {
                        ...a, state: "Error",
                        // @ts-ignore
                        error: error.message
                    };
                }
                return a;
            }));
        }
    }
}
